export const subtypeKeysMap = new Map([
    ['home_away_remote', 'Home Away wireless master switch'],
    ['on_off_remote', 'Wireless light switch'],
    ['toggle_remote', 'Wireless Aux switch'],
    ['roller_shutter_remote', 'Roller shutter wireless switch'],
    ['wakeup_sleep_remote', 'Wake Up  Sleep wireless switch'],
]);
